import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from "react-select";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import { PAYMENT_TYPE } from '../../../../state/helpers/Payment';

class CheckoutSectionContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function () { },
            forceSaveCard: content.forceSaveCard || false,
            forceSaveBankAccount : content.forceSaveBankAccount || false,
            hidePaymentSection: content.hidePaymentSection || false,
            hideShipping: content.hideShipping || false,
            submitButtonLabel: content.submitButtonLabel || '',
            defaultPaymentMethod: content.defaultPaymentMethod || 'credit-card',
            paymentMethods: content.paymentMethods || GlobalHelper.getPaymentMethodsCheckout(),
            acceptedCardBrands: content.acceptedCardBrands || [],
            paymentMethodOptions: GlobalHelper.getPaymentMethodOptionsCheckout(),
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handlePaymentMethods = this.handlePaymentMethods.bind(this)
        this.paymentMethodIsSelected = this.paymentMethodIsSelected.bind(this)
        this.handleAcceptedCardBrands = this.handleAcceptedCardBrands.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            forceSaveCard: this.state.forceSaveCard,
            forceSaveBankAccount : this.state.forceSaveBankAccount,
            hidePaymentSection: this.state.hidePaymentSection,
            hideShipping: this.state.hideShipping,
            submitButtonLabel: this.state.submitButtonLabel,
            defaultPaymentMethod: this.state.defaultPaymentMethod,
            paymentMethods: this.state.paymentMethods,
            acceptedCardBrands: this.state.acceptedCardBrands,
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    handlePaymentMethods(paymentMethods) {
        if (paymentMethods.length === 0) {
            paymentMethods = [{ value: 'credit-card' }]
        }
        let state = {
            paymentMethods: paymentMethods.map(option => {
                return option.value
            })
        }

        if (paymentMethods.length > 0) {
            state.defaultPaymentMethod = paymentMethods[0].value
        }

        this.setState(state, this.triggerChanged)
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            forceSaveCard: content.forceSaveCard || false,
            forceSaveBankAccount : content.forceSaveBankAccount || false,
            hidePaymentSection: content.hidePaymentSection || false,
            hideShipping: content.hideShipping || false,
            submitButtonLabel: content.submitButtonLabel || '',
            variables: nextProps.variables || {},
            acceptedCardBrands: content.acceptedCardBrands || [],
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handleAcceptedCardBrands(acceptedCardBrands) {
        this.setState({
            acceptedCardBrands: acceptedCardBrands.map(option => option.value)
        }, this.triggerChanged)
    }

    paymentMethodIsSelected(paymentMethod) {
        return this.state.paymentMethods.includes(paymentMethod)
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="form-group row">
                            <label className="col-3 col-form-label text-align-right" htmlFor="payBalanceButtonText">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.payment_methods_credit_memos_label"
                                    defaultMessage="Payment methods"
                                />
                            </label>
                            <div className="col-9">
                                <Select
                                    searchable={false}
                                    multi
                                    value={this.state.paymentMethods}
                                    onChange={this.handlePaymentMethods}
                                    options={this.state.paymentMethodOptions}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.payment_section.payment_methods_description"
                                        defaultMessage="This is the list of payment methods your customer will be able to pay from."
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.state.hidePaymentSection && this.paymentMethodIsSelected(PAYMENT_TYPE.CREDIT_CARD) && (
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-10">
                            <div className="form-group row">
                                <label className="col-3 col-form-label text-align-right" htmlFor="acceptedCardBrands">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.payment_section.accepted_card_brands"
                                        defaultMessage="Accepted Card Brands"
                                    />
                                </label>
                                <div className="col-9">
                                    <Select
                                        name="acceptedCardBrands"
                                        searchable={false}
                                        multi
                                        value={this.state.acceptedCardBrands}
                                        onChange={this.handleAcceptedCardBrands}
                                        options={GlobalHelper.getCardBrandOptions()}
                                        placeholder={this.props.intl.formatMessage({
                                            id: 'templates.sections.form.edit.content.payment_section.card_brands_placeholder',
                                            defaultMessage: 'All'
                                        })}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.card_brands_description"
                                            defaultMessage="This is the list of card brands your customer will be able to use for payment."
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hidePaymentSection"
                                name="hidePaymentSection"
                                value={this.state.hidePaymentSection}
                                checked={this.state.hidePaymentSection}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hidePaymentSection">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.checkout_section.hide_payment_section_label"
                                    defaultMessage="Hide payment section"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.checkout_section.hide_payment_section_description"
                                    defaultMessage="This will hide the payment section and show a submit button instead."
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {(!this.state.hidePaymentSection && this.paymentMethodIsSelected(PAYMENT_TYPE.CREDIT_CARD)) ?  <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="forceSaveCard"
                                name="forceSaveCard"
                                value={this.state.forceSaveCard}
                                checked={this.state.forceSaveCard}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="forceSaveCard">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.force_save_card_label"
                                    defaultMessage="Save card on file for all payments"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.force_save_card_description"
                                    defaultMessage="This will hide the save card checkbox and will save the card on file automatically."
                                />
                            </small>
                        </div>
                    </div>
                </div> : null}
                {(!this.state.hidePaymentSection && this.paymentMethodIsSelected(PAYMENT_TYPE.BANK_TRANSFER)) ? <div className="row">
                    <div className="col-2"/>
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="forceSaveBankAccount"
                                name="forceSaveBankAccount"
                                value={this.state.forceSaveBankAccount}
                                checked={this.state.forceSaveBankAccount}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="forceSaveBankAccount">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.force_save_bank_account_label"
                                    defaultMessage="Save bank account on file for all payments"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.force_save_bank_account_description"
                                    defaultMessage="This will hide the save bank account checkbox and will save the bank account on file automatically."
                                />
                            </small>
                        </div>
                    </div>
                </div>: null}
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideShipping"
                                name="hideShipping"
                                value={this.state.hideShipping}
                                checked={this.state.hideShipping}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideShipping">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.checkout_section.hide_shipping_label"
                                    defaultMessage="Hide shipping"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.checkout_section.hide_shipping_description"
                                    defaultMessage="This will hide the shipping information."
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {this.state.hidePaymentSection ? <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="submitButtonLabel">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.checkout_section.submit_button_label"
                            defaultMessage="Submit button label"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="submitButtonLabel"
                            value={this.state.submitButtonLabel}
                            onChange={this.handleFormChange}
                            id="submitButtonLabel"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage({ id: 'proposal.checkout.submit_btn' })}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.checkout_section.submit_button_description"
                                defaultMessage="This label will replace the submit button text"
                            />
                        </small>
                    </div>
                </div> : null}

            </div>
        );
    }
}

export default injectIntl(CheckoutSectionContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/checkout/input.component.jsx